export class QuestionnaireFormatObject {
  static readonly Gap: number = 10;
}
